// SidebarNavigation.js

import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  IconButton,
  Box,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "@mui/icons-material/Home";
import InfoIcon from "@mui/icons-material/Info";
import HelpIcon from "@mui/icons-material/Help";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import ArticleIcon from "@mui/icons-material/Article";
import ScoreboardIcon from "@mui/icons-material/Scoreboard";
import ShieldIcon from "@mui/icons-material/Shield";
import TableChartIcon from "@mui/icons-material/TableChart";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import VisibilityIcon from "@mui/icons-material/Visibility";

export function MenuButton({ onClick }) {
  return (
    <IconButton
      onClick={onClick}
      aria-label="Open menu"
      sx={{
        width: 40,
        height: 40,
        color: "#e6e8ee",
        transition: "color 160ms ease",
        "&:hover": { color: "#39d0ff", background: "rgba(57,208,255,0.08)" },
      }}
    >
      <MenuIcon sx={{ fontSize: 24 }} />
    </IconButton>
  );
}

export default function SidebarNavigation({
  currentPage,
  drawerOpen,
  onDrawerToggle,
}) {
  const navigate = useNavigate();

  // Only include pages with complete content
  const menuItems = [
    { label: "Home", icon: <HomeIcon />, page: "home", path: "/" },
    { label: "Records", icon: <EmojiEventsIcon />, page: "records", path: "/records" },
    { label: "Scorelines", icon: <ScoreboardIcon />, page: "scorelines", path: "/scorelines" },
    { label: "Clubs", icon: <ShieldIcon />, page: "clubs", path: "/clubs" },
    { label: "All-time table", icon: <TableChartIcon />, page: "table", path: "/all-time-table" },
    { label: "Seasons", icon: <CalendarMonthIcon />, page: "seasons", path: "/seasons" },
    { label: "Head to head", icon: <CompareArrowsIcon />, page: "h2h", path: "/head-to-head" },
    { label: "Race chart", icon: <ShowChartIcon />, page: "race", path: "/race" },
    { label: "Scorigami Watch", icon: <VisibilityIcon />, page: "watch", path: "/watch" },
    { label: "Articles", icon: <ArticleIcon />, page: "articles", path: "/articles" },
    { label: "About", icon: <InfoIcon />, page: "about", path: "/about" },
    { label: "FAQ", icon: <HelpIcon />, page: "faq", path: "/faq" },
    { label: "Contact", icon: <MailOutlineIcon />, page: "contact", path: "/contact" },
  ];

  const handleNavigation = (path) => {
    navigate(path);
    onDrawerToggle(false);
  };

  return (
    <Drawer
      anchor="left"
      open={drawerOpen}
      onClose={() => onDrawerToggle(false)}
      PaperProps={{
        sx: {
          background: "rgba(25, 25, 30, 0.95)",
          backdropFilter: "blur(10px)",
          borderRight: "1px solid rgba(255,255,255,0.1)",
          width: 280,
        },
      }}
    >
      <Box sx={{ pt: 2 }}>
        <List>
          {menuItems.map((item) => (
            <ListItem key={item.page} disablePadding>
              <ListItemButton
                selected={currentPage === item.page}
                onClick={() => handleNavigation(item.path)}
                sx={{
                  py: 2,
                  "&.Mui-selected": {
                    background: "linear-gradient(90deg, rgba(111,93,245,0.2), rgba(57,208,255,0.2))",
                    borderLeft: "4px solid #39d0ff",
                  },
                  "&:hover": {
                    background: "rgba(111,93,245,0.1)",
                  },
                }}
              >
                <ListItemIcon
                  sx={{
                    color: currentPage === item.page ? "#39d0ff" : "#b0b0b0",
                    minWidth: 48,
                  }}
                >
                  {item.icon}
                </ListItemIcon>
                <ListItemText
                  primary={item.label}
                  sx={{
                    color: currentPage === item.page ? "#39d0ff" : "#fff",
                    "& .MuiTypography-root": {
                      fontWeight: currentPage === item.page ? 600 : 400,
                    },
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
    </Drawer>
  );
}